<template>
    <div>
        <form method="get">
            <div class="row">
                <div class="col-12 mb-md-0 mb-3 col-sm-6 col-md-3">
                    <app-select
                        label="Integration Type"
                        placeholder="Integration Type"
                        name="integration-type"
                        id="integration-type"
                        :use-search="false"
                        :is-multiple="false"
                        :options="integrationTypes"
                        v-model="selectedIntegrationType"
                    ></app-select>
                </div>
                <div class="col-12 mb-md-0 mb-3 col-sm-6 col-md-3">
                    <app-select
                        label="Table"
                        placeholder="Table"
                        name="table"
                        id="filter-table"
                        :is-multiple="false"
                        :options="masterTablesOptions"
                        v-model="selectedTable"
                        :is-disabled="disabledMasterTable"
                    ></app-select>
                </div>
                <div class="col-12 mb-md-0 mt-4_5 col-sm-6 col-md-3">
                    <button-set>
                        <app-button
                            type="primary"
                            @click.prevent.default="onSearch"
                            :is-disabled="disabledSearch"
                        >
                            Search
                        </app-button>
                    </button-set>
                </div>
                <div class="col-12 mb-md-0 mt-4_5 col-sm-6 col-md-3 text-right" v-if="selectedIntegrationType">
                    <app-button :link="route('metadata.master-tables-tool.create', {type: selectedIntegrationType})" type="success">
                        <ion-icon name="add-outline" class="mr-1 md hydrated"></ion-icon>
                        Add New Master Table
                    </app-button>
                </div>
            </div>
        </form>

        <full-page-loader v-if="loading"></full-page-loader>

        <table-fields
            v-if="masterFields.length > 0"
            :master-fields="masterFields"
        ></table-fields>

        <div class="col6 mt-4" v-if="showAddFields">
            <app-button :link="route('metadata.master-fields-tool.create', {
                type: selectedIntegrationType,
                table: selectedTable
            })" type="success">
                <ion-icon name="add-outline" class="mr-1 md hydrated"></ion-icon>
                Add New Master Field
            </app-button>
        </div>
    </div>
</template>

<script>
import Table from "./Table";
import route from "ziggy-js";
import debounce from '../../../helpers/debounce'
import TableFields from "./Table";

export default {
    components: {
        TableFields,
        'table-platforms': Table
    },
    props: {
        integrationTypes: {
            type: Array,
            default() {
                return [];
            }
        },
        masterTables: {
            type: Array,
            default() {
                return [];
            }
        },
        params: {
            type: [Array, Object],
            default() {
                return [];
            }
        },
    },
    data() {
        return {
            selectedIntegrationType: this.params.integrationType,
            selectedTable: this.params.masterTable,
            masterFields: [],
            showAddFields: false,
            loading: false
        };
    },
    mounted() {
        if (this.params.integrationType && this.params.masterTable) {
            this.onSearch();
        }
    },
    methods: {
        onSearch: debounce(function () {
            this.loading = true
            this.showAddFields = false
            axios.post(route('metadata.master-tables-tool.table-fields'), {
                integration: +this.selectedIntegrationType,
                table: +this.selectedTable
            }).then(response => {
                this.masterFields = response.data;

                if (this.masterFields.length > 0) {
                    this.$notifications.success('The data was received successfully');
                } else {
                    this.$notifications.error('This table does not have Master Fields');
                }
                this.showAddFields = true
                this.loading = false
            }).catch(err => {
                console.error(err.message);
                this.$notifications.error('Error retrieving data');
                this.loading = false
            });
        }, 1000)
    },
    computed: {
        masterTablesOptions() {
            let options = [];
            this.masterTables.forEach(option => {
                if (+this.selectedIntegrationType === option.integration_type_id) {
                    options.push({
                        id: option.id,
                        title: option.title,
                    });
                }
            });
            return options;
        },
        disabledMasterTable() {
            return !Boolean(this.selectedIntegrationType);
        },
        disabledSearch() {
            return !Boolean(this.selectedTable);
        }
    }
}
</script>
